import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EventStatus } from "../../store/events/types";
import { LiveHlsDataResponse, LiveStreamStatus, fitEventLiveViewMetricLssList } from "./types";
import { WssResponseType } from "./types.wss";

interface Slice {
  requiredEventStatus: EventStatus | null;
  prevLiveStreamStatus: LiveStreamStatus | null;
  liveStreamStatus: LiveStreamStatus | null;
  requiredLiveStreamStatus: LiveStreamStatus | null;
  isEventLiveViewMetricLssFit: boolean;
  liveData: LiveHlsDataResponse | null;
  isChangeEventStatusError: boolean;
  lastStreamingAction: WssResponseType | null,
}

const initialState: Slice = {
  requiredEventStatus: null,
  prevLiveStreamStatus: null,
  liveStreamStatus: null,
  requiredLiveStreamStatus: null,
  isEventLiveViewMetricLssFit: false,
  liveData: null,
  isChangeEventStatusError: false,
  lastStreamingAction: null,
};

const broadcastSlice = createSlice({
  name: "broadcast",
  initialState,
  reducers: {
    setLiveStreamStatus(state, { payload: liveStreamStatus }: PayloadAction<LiveStreamStatus|null>) {
      // console.log(liveStreamStatus, " --> null");
      state.liveStreamStatus = liveStreamStatus;
      if (liveStreamStatus && !/PRE_/.test(liveStreamStatus)){
        state.prevLiveStreamStatus = state.liveStreamStatus; // stable status only
      }
      state.requiredLiveStreamStatus = null;
      state.isEventLiveViewMetricLssFit = !!liveStreamStatus &&
        fitEventLiveViewMetricLssList.includes(liveStreamStatus);
    },
    setRequiredLiveStreamStatus(state, { payload }: PayloadAction<LiveStreamStatus|null>) {
      // console.log(state.liveStreamStatus, " --> ", payload);
      state.requiredLiveStreamStatus = payload;
    },
    setLiveData(state, { payload }: PayloadAction<LiveHlsDataResponse|null>) {
      state.liveData = payload;
    },
    setIsEMPButtonError(state, { payload }: PayloadAction<boolean>) {
      state.isChangeEventStatusError = payload;
    },
    setRequiredEventStatus(state, { payload }: PayloadAction<EventStatus|null>) {
      state.requiredEventStatus = payload;
    },
    setLastStreamingAction(state, { payload }: PayloadAction<WssResponseType|null>) {
      state.lastStreamingAction = payload;
    },
  }
});

export const {
  setLiveStreamStatus,
  setLiveData,
  setIsEMPButtonError,
  setRequiredEventStatus,
  setLastStreamingAction,
  setRequiredLiveStreamStatus,
} = broadcastSlice.actions;


export default broadcastSlice.reducer;